// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_ReserveFloorResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * GET /ai/credits/pricing/reserve-floor — Full-gated only.
 *
 * The worst-case flat-cap reserve the admission gate (POST /ai/credits/reserve)
 * would hold for ONE agent turn, priced exactly the way controllers/ai/credits.php
 * prices it: priceUsage(model, hit=0, miss=RESERVE_ASSUMED_INPUT_MISS_TOKENS,
 * out=RESERVE_OUTPUT_TOKEN_CAP). Lets the Pacotes tab flag a pack too small to
 * fund a single prompt (§2.7) WITHOUT re-deriving the pricing formula in
 * TypeScript — a second implementation of this formula is exactly the defect
 * class this refactor exists to remove.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_ReserveFloorResponseDados {
model_name: string
reserve_floor_micro: number
}

export type AiCredits_ReserveFloorResponse = ApiResponse<AiCredits_ReserveFloorResponseDados>;

registerResponseContract('AiCredits_ReserveFloorResponse', {
  model_name:          { type: 'string',  required: true },
  reserve_floor_micro: { type: 'number',  required: true },
})
